import { withGoogleMap, withScriptjs } from 'react-google-maps';
import { compose, setDisplayName } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import withGoogleMapsProps from './withGoogleMapsProps';
import { selectCurrentAppointment } from '../../redux/appointmnents/selectors';
import {
  selectActiveAppointmentId,
  selectActiveTodoItemTaskGeoLocations,
  selectActiveTodoItemTaskId,
  selectHistoryAppointmentList,
  selectUpcomingAppointmentList,
} from '../../redux/healthboard/selectors';
import * as geoLocations from '../../redux/healthboard/requests/get-geoLocations-req';

const mapStateToProps = state => ({
  currentAppointment: selectCurrentAppointment(state),
  appointmentsList: selectUpcomingAppointmentList(state),
  currentAppointmentId: selectActiveAppointmentId(state),
  activeTodoItemTaskId: selectActiveTodoItemTaskId(state),
  geolocations: selectActiveTodoItemTaskGeoLocations(state),
  historyAppointmentsList: selectHistoryAppointmentList(state),
});
const mapDispatchToProps = {
  getLocationsDetails: geoLocations.actions.send,
};

const enhance = component =>
  compose(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    ),
    injectIntl,
    setDisplayName('GoogleMaps'),
    withGoogleMapsProps,
    withScriptjs,
    withGoogleMap,
  )(component);

export default enhance;



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/enhance.js